<template>
  <div :ref="'rm_' + index" class="rm">
    <div v-if="selected == index" class="rm-form row">

      <div>
        <div class="row mb-15">
          <input
            v-model="form.first_name"
            class="input-text"
            placeholder="First Name"
            type="text"
          />
        </div>
        <div class="row mb-15">
          <input
            v-model="form.last_name"
            class="input-text"
            placeholder="Last Name"
            type="text"
          />
        </div>
        <div class="row mb-15">
          <input
            v-if="warn_email"
            v-model="form.email_address"
            class="input-text warn-input"
            placeholder="Email"
            type="text"
          />
          <input
            v-else
            v-model="form.email_address"
            class="input-text"
            placeholder="Email"
            type="text"
          />
          <transition><p v-if="warn_email" id="warn_email" class="warn">You must provide an email address to continue.</p></transition>
        </div>
        <div class="row mb-15">
          <input
            v-if="warn_birthday"
            v-model="form.birthday"
            class="input-text warn-input"
            placeholder="Birthday (MM/DD/YYYY)"
            type="text"
          />
          <input
            v-else
            v-model="form.birthday"
            class="input-text"
            placeholder="Birthday (MM/DD/YYYY)"
            type="text"
          />
          <transition><p v-if="warn_birthday" id="warn_birthday" class="warn">You must provide your birthday to continue.</p></transition>
        </div>

        <div class="row mb-15 checkbox-row">
          <label for="checkbox-consent">
            <input
              id="checkbox-consent"
              v-model="form.consent"
              type="checkbox"
            />
            <span class="shadow">By submitting your information, you agree to receive marketing emails from Cincinnati's Fidelity Hotel</span>
          </label>
          <transition><p v-if="warn_consent" id="warn_consent" class="warn">You must accept to continue.</p></transition>
        </div>
      </div>

      <div>
        <button
          class="btn btnSpecial"
          type="button"
          @click="emitRegistrationMethodData()"
        >
          Continue
        </button>
      </div>

    </div>
  </div>
  <!-- rm -->
</template>
<script>
import Axios from "axios";
import {HTTP} from '@/utilities/http'

export default {
  name: "registration_method",
  props: [
    "index",
    "selected",
    "selected_tos",
    "color_background_button",
    "color_text_button",
    "registration_method",
  ],
  data() {
    return {
      selected_error: false,
      warn_email: false,
      warn_birthday: false,
      warn_consent: false,
      form: {
        first_name: "",
        last_name: "",
        email_address: "",
        birthday: "",
        consent: 0,
      },
      revinate: {
        list_token: "edd24c28-60f9-4176-99d4-ee9bc1b4c65f",
        url: "https://contact-api.inguest.com/api/add-contacts-to-lists",
      },
    };
  },
  mounted() {
  },
  methods: {
    selectRegistrationMethod: function (index) {
      this.$emit("changeSelected", index);
    },
    selectTermsOfService: function (index) {
      this.$emit("changeSelectedTOS", index);
    },
    emitRegistrationMethodData: function () {

      var emitted = {
        registration_method_id: this.registration_method.registration_method_id,
        rateplan_id: this.registration_method.id,
        email_address: null,
        last_name: null,
        first_name: null,
        birthday: null,
      };

      if (!this.form.email_address) {
        this.warn_email = true;
      }

      if (!this.form.birthday) {
        this.warn_birthday = true;
      }

      if (!this.form.consent) {
        this.warn_consent = true;
      }

      if (this.form.email_address && this.form.birthday && this.form.consent) {
        this.warn_email = false;
        this.warn_birthday = false;
        this.warn_consent = false;
        emitted.registration_method_id = 3;
        emitted.email_address = this.form.email_address;
        emitted.last_name = this.form.last_name;
        emitted.first_name = this.form.first_name;
        emitted.birthday = this.form.birthday;

        const revinate_data = {
          tokens: [this.revinate.list_token],
          contacts: [
            { email: this.form.email_address, first_name: this.form.first_name, last_name: this.form.last_name, birthday: this.form.birthday },
          ]
        };
        Axios.post(this.revinate.url, revinate_data).then(response => {
          this.$emit('emitRegistrationMethodData', emitted);
        }).catch(error => {
          this.$emit('error', 'Error registering with email address.');
        });
      }
    },
  },
};
</script>
<style>

.v-enter-active,
.v-leave-active {
  transition: opacity 1.5s ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}

.shadow {
  text-shadow: 0px 0px 10px black;
}

#logo {
  padding: 3% !important;
}

.btnSpecial {
  text-transform: uppercase;
  font-size: 12px !important;
  height: 65px;
  margin-bottom: 10px;
  -webkit-filter: brightness(1);
  filter: brightness(1);
}

.btnSpecial:hover {
  -webkit-filter: brightness(1.3);
  filter: brightness(1.3);
}

input {
  color: white;
}

.warn-input {
  border-top: 2px solid #d7403a !important;
  border-left: 2px solid #c22b51 !important;
  border-right: 2px solid #c22b51 !important;
  background: #f9f9f9;
  position: relative;
  z-index: 1;
}

.warn {
  background: #FFFFFF;
  background: -webkit-gradient(linear, left top, left bottom, from(rgba(255, 255, 255, 0)), to(rgba(199, 113, 128, 1)));
  background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, rgba(199, 113, 128, 1) 100%);
  color: #ffcfcf;
  border-radius: 8px;
  padding: 50px 0 30px;
  font-size: 14px;
  font-weight: bold;
  text-align: center;
  text-shadow: 1px 1px 1px #864a4a;
  position: relative;
  top: -30px;
}

#rms { max-width: 550px; }

#logo img {
  max-width: 375px;
}

.rm a,
.rm span.text-link {
  color: white;
  text-decoration: underline;
  cursor: pointer;
}

.rm .rm-form {
  background: none;
  width: 75%;
  margin: auto;
  border: none;
}

.rm .input-text {
  border-radius: 10px;
  border: none;
  border-bottom: 1px solid #cccccc;
  overflow: visible;
  width: 100%;
  padding: 15px;
  font-size: 16px;
  text-align: left;
}

.rm .btn {
  background: #8B5B34;
  border: 2px solid #8B5B34;
  color: white;
  border-radius: 10px;
  width: 100%;
  padding: 20px;
  cursor: pointer;
  font-size: 20px;
  font-weight: bold;
}

.rm .btn:hover {
  opacity: 90%;
}

.rm label {
  display: inline-block;
  padding: 0px;
  width: 100%;
  font-size: 18px;
  margin: 10px 0;
}

.rm label span {
  font-size: 14px;
  font-weight: bold;
  padding-left: 6px;
  float: left;
  width: 88%;
}

@media screen and (max-device-width: 800px) {
  .rm .rm-form {
    width: 75%;
    margin: 0 auto;
  }
}

.checkbox-row {
  text-align: left;
}

.checkbox-row input {
  margin-right: 10px;
  border-radius: 5px;
  float: left;
  width: 5%;
}

.input-text {
  text-align: center;
}

.top-btn {
  margin-top: 1rem;
}
</style>
